export function mismatchValidator(word1: string, word2: string): boolean {
    if (!word1 || !word2) {
        return false;
    }
    return word1 !== word2;
}
